import {register} from '@shopify/theme-sections';

const selectors = {
  slider: '[data-slider]',
};

export default register('image-text-cta', {
  onLoad() {
    const container = this.container;
    const elem = container.querySelector(selectors.slider);
    if (!elem) return;

    return new Flickity(elem, {
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      watchCSS: true,
      contain: true,
      groupCells: true,
    });
  },
});
